import BaseService from './base'

export default class MenuService extends BaseService {
  static resource() {
    return 'api/v1/menu'
  }
}
